// Footer
const Footer = () => {
  return (
    <footer className="bg-neutral-950 py-8 border-t border-neutral-900">
      <div className="max-w-[1800px] mx-auto px-4 sm:px-6 lg:px-12">
        <div className="flex flex-col md:flex-row items-center justify-between gap-3 sm:gap-4 text-center md:text-left">

          {/* Left Text */}
          <p className="text-neutral-600 text-xs sm:text-sm tracking-wider">
            © 2025 TagTeam Studios. All Rights Reserved.
          </p>

          {/* Right Text */}
          <p className="text-neutral-700 text-[0.65rem] sm:text-xs tracking-[0.3em]">
            SINCE DECEMBER 28, 2015
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
